import {AxiosInstance} from "axios";
import {Alert} from "@/alert/interfaces";

const AlertResource = (client: AxiosInstance) => {
    return {
        /**
         * Get the active alerts.
         */
        async index(params: {version?: string | null} = {}): Promise<Alert[]> {
            return client.get("alerts", {params})
                .then((response) => response.data.data);
        }
    };
};

export default AlertResource;
